export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.32 18.25">
    <path d="M2.25 18.25a.7.7 0 0 1-.6-.33.69.69 0 0 1 .05-.82 10 10 0 0 0 1.88-3A7.4 7.4 0 0 1 0 8c0-4.41 4.56-8 10.16-8s10.16 3.59 10.16 8-4.56 8-10.16 8a12.84 12.84 0 0 1-2.29-.21 13.2 13.2 0 0 1-5.46 2.43zm7.91-16.83c-4.82 0-8.74 3-8.74 6.59a6.15 6.15 0 0 0 3.34 5.17.72.72 0 0 1 .33.78 6.85 6.85 0 0 1-1 2.32 9.18 9.18 0 0 0 3.13-1.75.72.72 0 0 1 .63-.18 11 11 0 0 0 2.34.25c4.81 0 8.71-2.95 8.71-6.6S15 1.42 10.16 1.42z" />
  </svg>
);
